module.exports = __webpack_public_path__ + "img/platillo_farolito.23243d31.webp";